(function (angular) {
    'use strict';

    angular.module('whatsApp')
        /**
         *
         */
        .controller('whatsAppVerifyPhoneController',
        ['$scope', '$stateParams', 'whatsAppServices', '$uibModalInstance', 'phoneNumber', 'growlService', '$rootScope',
            function ($scope, $stateParams, whatsAppServices, $uibModalInstance, phoneNumber, growlService, $rootScope) {
                $scope.close = function(){
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.verifyMethod = "sms";
                $scope.verifyOptions = [{value: "sms", label: "SMS"}, {value: "voice", label: "Voice"}];
                
                $scope.save = function(){
                    whatsAppServices.sendVerificationCode($stateParams.pickedApiSpaceId, phoneNumber, $scope.code)
                        .then(function(result){
                            growlService.success('WhatsApp phone number verified correctly');
                            $rootScope.$broadcast('WhatsApp channel configured', phoneNumber);
                            $uibModalInstance.close('save');
                        }).catch(function(error){
                            growlService.danger("WhatsApp phone number wasn't verified correctly due to: "+error.statusText);
                        });
                }
                
                $scope.startVerification = function(){
                    whatsAppServices.startVerificationProcess($stateParams.pickedApiSpaceId, phoneNumber, $scope.verifyMethod, $scope.pin)
                        .then(function(result){
                            growlService.success('Start of WhatsApp verification started correctly');
                        }).catch(function(error){
                            growlService.danger("WhatsApp verification wasn't started correctly due to: "+error.statusText);
                        });
                }
        }]);


})(window.angular);